import axios from "axios";
import config from "./config";

export default class Session {
	constructor() {
		this.apiBase = config.apis.base;
		this.getAddressLookup = this.getAddressLookup.bind(this);
		this.getHomeData = this.getHomeData.bind(this);
    this.getBallotData = this.getBallotData.bind(this);
    this.getRaceData = this.getBallotData.bind(this);
    this.getAmendments = this.getAmendments.bind(this);
	}

	getAddressLookup(address) {
		let url = config.apis.targetSmartAPI;
		url = url + address + "&search_type=address&state=OR";
		return axios
      .get(url)
      .then(response => {
        let matchData = response.data.message.match_data
        if (matchData) {
          let ballot = {
            cd: matchData["vb.vf_cd"] || "",
            sldl: matchData["vb.vf_hd"] || "",
            sldu: matchData["vb.vf_sd"] || "",
            county: matchData["vb.vf_county_name"] || "",
						municipal: matchData["vb.vf_municipal_district"] || "",
            zip: matchData["vb.vf_reg_cass_zip"] || "",
          }
          return ballot
        } else {
          return {
            lookupError: "Address is not in the state of Oregon.",
          }
        }
      })
      .catch(error => {
        let response =
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message
        return {
          lookupError: response,
        }
      })
	}

	getHomeData() {
		let url = this.apiBase + config.apis.races + "?is_statewide=true";
		return axios
			.get(url)
			.then((response) => {
				let data = response && response.data && response.data;
				return data;
			})
			.catch((error) => {
				let status = error.response && error.response.status;
				if (status === 500) {
					window.history.pushState("", "", "/500");
				}
				let response =
					error.response &&
					error.response.data &&
					error.response.data.error &&
					error.response.data.error.message;
				return {
					lookupError: response || "Error",
				};
			});
	}

	getBallotData(payload) {
		let query = config.apis.ballotFilters
			.replace("{sldl}", payload.sldl || "")
			.replace("{sldu}", payload.sldu || "")
			.replace("{cd}", payload.cd || "")
			.replace("{county}", payload.county || "");
		let url = this.apiBase + config.apis.races + "?filters=" + escape(query);
		return axios
			.get(url)
			.then((response) => {
				let data = response && response.data;
				return data;
			})
			.catch((error) => {
				let status = error.response && error.response.status;
				if (status === 500) {
					window.history.pushState("", "", "/500");
				}
				let response =
					error.response &&
					error.response.data &&
					error.response.data.error &&
					error.response.data.error.message;
				return {
					lookupError: response || "Error",
				};
			});
	}

	getRaceData(payload) {
		let query = config.apis.raceFilters.replace("{race}", payload.race);
		let url = this.apiBase + config.apis.races + "?filters=" + escape(query);
		return axios
			.get(url)
			.then((response) => {
				let data = response && response.data;
				return data;
			})
			.catch((error) => {
				let status = error.response && error.response.status;
				if (status === 500) {
					window.history.pushState("", "", "/500");
				}
				let response =
					error.response &&
					error.response.data &&
					error.response.data.error &&
					error.response.data.error.message;
				return {
					lookupError: response || "Error",
				};
			});
	}

	getAmendments(query) {
		query = query || ""
		let url = this.apiBase + config.apis.amendments + query;
		return axios
			.get(url)
			.then((response) => {
				let data = response && response.data;
				return data;
			})
			.catch((error) => {
				let status = error.response && error.response.status;
				if (status === 500) {
					// window.history.pushState("", "", "/500");
				}
				let response =
					error.response &&
					error.response.data &&
					error.response.data.error &&
					error.response.data.error.message;
				return {
					lookupError: response || "Error",
				};
			});
	}
}
